import {
  AssignableType,
  BasketballPractice,
  TaskEvent,
  TaskEventType,
  TaskableType,
  UserRole,
} from '@hefe/models';
import { currentUserSelector } from '@hefe/store';
import { Descriptions, Space } from 'antd';
import { useMemo } from 'react';
import { FaUser, FaUsers } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import TaskAssignmentSelectComponent from '../../../../tasks/components/task-assignment-select/task-assignment-select.component';

interface PracticeDetailsClubComponentProps {
  practice: BasketballPractice;
}

export default function PracticeDetailsClubComponent(
  props: PracticeDetailsClubComponentProps
) {
  const { practice } = props;

  const user = useSelector(currentUserSelector);

  const tasks = useMemo(() => {
    if (!practice?.club_tasks) return null;

    return practice?.club_tasks?.map((task) => {
      const event = {
        assignments: task?.assignments ?? [],
        id: `1_${practice.id}`,
        type: TaskEventType.BASKETBALL_PRACTICE,
      } as TaskEvent;

      const returnValue = [];

      returnValue.push(
        <Space key={`teams_${task.id}`}>
          <FaUsers />
          <TaskAssignmentSelectComponent
            key={`teams_${task.id}`}
            assignments={task?.assignments ?? []}
            event={event}
            type={TaskableType.CLUB}
            taskId={`club_${task.id}`}
            assignableType={AssignableType.BASKETBALL_TEAM}
            disabled={!user?.role?.includes(UserRole.BB_ADMIN)}
            task={task}
          />
        </Space>
      );

      returnValue.push(
        <Space key={`user_${task.id}`}>
          <FaUser />
          <TaskAssignmentSelectComponent
            assignments={task?.assignments ?? []}
            event={event}
            type={TaskableType.CLUB}
            taskId={`club_${task.id}`}
            assignableType={AssignableType.USER}
            disabled={!task?.allow_interaction}
            task={task}
          />
        </Space>
      );

      return (
        <Descriptions.Item label={task.name} key={task.id}>
          <Space direction="vertical">{returnValue}</Space>
        </Descriptions.Item>
      );
    });
  }, [practice, user]);

  return (
    <Descriptions column={1} size="small" bordered>
      {tasks}
    </Descriptions>
  );
}
